import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as noticiaApi from '../api/noticias'
import { fetchItems } from '../api/categorias'
import { useSelector } from 'react-redux'

const EditNoticia = ({ edit }) => {
  const translations = useSelector(state => state.translations.translations)
  const noticiasTranslations = translations['system-noticias']

  const [categorias, setCategorias] = useState([])

  useEffect(() => {
    fetchItems().then(res => {
      let categoriasOptions = []
      res.data.forEach(categoria => {
        categoriasOptions.push({ value: categoria._id, label: categoria.nome })
      })
      setCategorias(categoriasOptions)
    })
  }, [])

  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'titulo',
      type: 'text',
      title: "Título notícia",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: 'subtitulo',
      type: 'text',
      title: "Frase de apoio",
      options: {
        optional: true
      }
    },
    {
      name: 'categoria',
      type: 'select',
      title: "Categoria em que a notícia se encaixa",
      selectOptions: categorias,
      options: {
        populated: true
      }
    },
    {
      name: 'data_noticia',
      type: 'date',
      options:{
        formatHora: "Pp"
      },
      title: "Data de criação"
    },
    {
      name: 'data_publicacao',
      type: 'date',
      options:{
        formatHora: "Pp"
      },
      title: 'Data de publicação',
      subtitle: "Quando a notícia vai para o ar",
      options: {
        optional: true
      }
    },
    // {
    //   name: 'destacar',
    //   type: 'checkbox',
    //   title: "Seleção do destaque",
    //   subtitle: "Noticia"
    // },
    {
      name: 'corpo',
      type: 'tiny',
      title: "Corpo da notícia",
      conditional: [
        {
          name: 'categoria',
          nequal: "61201ccf67375f2f903d4790"
        }
      ],
      options: {
        optional: true
      }
    },
    // {
    //   name: 'video',
    //   type: 'text',
    //   title: noticiasTranslations['edit-link'],
    //   conditional: [
    //     {
    //       name: 'categoria',
    //       equal: "61201ccf67375f2f903d4790"
    //     }
    //   ],
    //   // options: {
    //   //   optional: true
    //   // }
    // },
    {
      name: 'img',
      type: 'dragdrop',
      title: "Imagem notícia",
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
      conditional: [
        // { /** VIDEO NECESSITA DE UMA THUMBNAIL */
        //   name: 'categoria',
        //   nequal: "61201ccf67375f2f903d4790" 
        // },
        {
          name: 'categoria',
          nequal: "60b7b815cb748f4d8447b8b1"
        }
      ],
    },
    // {
    //   name: 'galeria',
    //   type: 'dragdrop',
    //   title: noticiasTranslations['edit-galeria'],
    //   conditional: [
    //     {
    //       name: 'categoria',
    //       equal: "60b7b815cb748f4d8447b8b1"
    //     }
    //   ],
    //   options: {
    //     customRemoveImgFromArray: (id, imgid) => noticiaApi.removeImgGaleria(id, imgid)
    //   }
    // },
    {
      name: 'url',
      type: 'text',
      title: "Url amigável",
      subtitle: "Gerada automaticamente altere somente se necessário",
      validation: {
        required: true
      },
      tooltip: {
        text: "o que irá no link para encontrar a notícia"
      }
    }
  ]
  return (
    <EditPage
      title={edit ? "Editar notícia" : "Adicionar notícia"}
      subtitle={edit ? "Editando informações da notícia" : "Adicionando informações da notícia"}
      selectedData={selectedData} 
      addFunction={noticiaApi.addItem}
      fetchFunction={noticiaApi.fetchItem}
      editFunction={noticiaApi.editItem}
      uploadFunction={noticiaApi.uploadNoticia}
      edit={edit}
      url='noticias'
    />
  )
}

export default EditNoticia
